<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="700px">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col cols="8">
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <service-status-list-select
          :service-status-id="statusId"
          :service-status-name="statusName"
          @onSelect="onServiceStatusChange"
          :outlined="outlinedInputs"
          :isDisabled="false"
        ></service-status-list-select>
      </v-col>
      <v-col>
        <date-range-picker
          :gt-date-from-string="startDate"
          :gt-date-to-string="endDate"
          @onRangeSelected="onDateRangeSelected"
          :outlined="outlinedInputs"
          :rangeStart="rangeStart"
          :rangeEnd="rangeEnd"
        ></date-range-picker>
      </v-col>
      <v-col>
        <v-radio-group v-model="rateType" row v-if="false">
          <v-radio value="PI" label="Item Based"></v-radio>
          <v-radio value="PP" label="Person Based"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model.number="qty"
          type="number"
          label="qty"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="adults"
          type="number"
          label="Adults"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="children"
          type="number"
          label="Children"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="infants"
          type="number"
          label="Infants"
          :outlined="outlinedInputs"
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model.number="perItem"
          type="number"
          label="Price Per Item"
          :outlined="outlinedInputs"
          :disabled="rateType == 'PP'"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="perAdult"
          type="number"
          label="Price Per Adult"
          :outlined="outlinedInputs"
          :disabled="rateType == 'PI'"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="perChild"
          type="number"
          label="Price Per Child"
          :outlined="outlinedInputs"
          :disabled="rateType == 'PI'"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="perInfant"
          type="number"
          label="Price Per Infant"
          :outlined="outlinedInputs"
          :disabled="rateType == 'PI'"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <rate-type-list-select
          v-model="rateType"
          :outlined="outlinedInputs"
          hideNotInUse
        />
      </v-col>
      <v-col>
        <taxes-list-select
          :outlined="outlinedInputs"
          v-model="taxCode"
          hide-details
          @onSelectTaxType="onTaxSelect"
        ></taxes-list-select>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col>
        <v-container>
          <v-row justify="end">
            <div class="headline">Total: {{ total }}</div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <pricing-logs-dialog
      :show="showPricingLog"
      @close="showPricingLog = false"
      v-model="itineraryItem.pricing.logs"
    />
    <template v-slot:actions>
      <v-btn @click="onShowLogs">Logs</v-btn>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>from{{ startDate }}, end: {{ endDate }}</code>
      <code>value: {{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import { ALL_RATE_TYPES_SEARCH_QUERY } from "../../../../../constants/graphql";
import { durationInDays } from "../../../../../helpers";
import BasicDialog from "../../../shared/BasicDialog";
import DateRangePicker from "../../../shared/DatesRangePicker";
import RateTypeListSelect from "../../../shared/RateTypeListSelect.vue";
import ServiceStatusListSelect from "../../../shared/ServiceStatusListSelect.vue";
import TaxesListSelect from "../../../shared/TaxesListSelect.vue";
import PricingLogsDialog from "./PricingLogsDialog.vue";
const randomize = require("randomatic");
const moment = require("moment");
export default {
  name: "charge-edit-dialog",

  components: {
    BasicDialog,
    DateRangePicker,
    RateTypeListSelect,
    ServiceStatusListSelect,
    TaxesListSelect,
    PricingLogsDialog,
  },

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    header: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.serviceName : "New Charge",
      adults: this.value ? this.value.adults : 2,
      children: this.value ? this.value.children : 0,
      infants: this.value ? this.value.infants : 0,
      qty: this.value ? this.value.qty : 1,
      perAdult:
        this.value && this.value.pricing ? this.value.pricing.adultSell : 0,
      perChild:
        this.value && this.value.pricing ? this.value.pricing.childSell : 0,
      perInfant:
        this.value && this.value.pricing ? this.value.pricing.infantSell : 0,
      perItem:
        this.value && this.value.pricing ? this.value.pricing.itemSell : 0,
      rateType:
        this.value &&
        this.value.rateTypeCode &&
        this.value.rateTypeCode.toString() != ""
          ? this.value.rateTypeCode
          : "PP",
      taxCode: this.value ? this.value.taxCode : "",
      startDate:
        this.value && this.values.startDate
          ? this.value.startDate
          : this.header
          ? this.header.endDate
          : "", //http://tracker.globetrack.ie/issues/5712
      endDate:
        this.value && this.value.endDate
          ? this.value.endDate
          : this.header
          ? this.header.endDate
          : "", //http://tracker.globetrack.ie/issues/5712
      rangeStart: this.header ? this.header.startDate : "",
      rangeEnd: this.header ? this.header.endDate : "",
      statusId: this.value ? this.value.statusId : "",
      statusName: this.value ? this.value.status : "Quotation",
      showPricingLog: false,
      includeCommission: this.value ? this.value.includeCommission : true,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "" && this.startDate != "" && this.endDate != "";
    },
    title() {
      return `${this.value && this.value.id ? "Edit" : "Add"} Charge`;
    },
    total() {
      let total = 0;
      if (this.rateTypes && this.rateTypes.edges) {
        const selectedRateType = this.rateTypes.edges.find(
          (item) => item.node.code == this.rateType
        );
        if (selectedRateType) {
          const perPerson = selectedRateType.node.includePax;
          const perDay = selectedRateType.node.includeDays;
          total = perPerson
            ? (
                Number(this.perAdult) * Number(this.adults) +
                Number(this.perChild) * Number(this.children) +
                Number(this.perInfant) * Number(this.infants)
              ).toFixed(2)
            : (Number(this.perItem) * Number(this.qty)).toFixed(2);
          if (perDay) {
            const duration =
              Number(durationInDays(this.startDate, this.endDate)) + 1;
            total = total * duration;
          }
        }
      }
      return total;
    },
    itineraryItem() {
      const currency = this.$store.getters.itineraryAgentCurrency;
      return {
        id: this.value && this.value.id ? this.value.id : randomize("Aa0", 32),
        startDate: this.startDate,
        endDate: this.endDate,
        serviceId: "",
        status: this.statusName,
        statusName: this.statusName,
        statusId: this.statusId,
        qty: this.qty,
        price: this.total,
        serviceType: "MANDATORY_CHARGES",
        serviceName: this.name,
        supplierName: "Charges",
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        isIncluded: true,
        isOptional: false,
        rateTypeCode: this.rateType,
        taxCode: this.taxCode,
        selected: false,
        customPricing: true,
        orderNo: 5000,
        remarks: {},
        extras: [],
        includeCommission: this.includeCommission,
        pricing: {
          adultBuy: 0,
          adultSell: this.perAdult,
          childBuy: 0,
          childSell: this.perChild,
          infantBuy: 0,
          infantSell: this.perInfant,
          itemBuy: 0,
          itemSell: this.perItem,
          rateTypeCode: this.rateType,
          currencyBuy: currency,
          currencyBuyExchangeRate:
            this.value && this.value.pricing
              ? this.value.pricing.currencyBuyExchangeRate
              : undefined,
          currencySell: currency,
          currencySellExchangeRate:
            this.value && this.value.pricing
              ? this.value.pricing.currencySellExchangeRate
              : undefined,
          itemBased: this.rateType == "PI",
          logs:
            this.value && this.value.pricing && this.value.pricing.logs
              ? [...this.value.pricing.logs]
              : [],
        },
      };
    },
  },

  watch: {
    header(newHeader) {
      this.startDate = newHeader ? newHeader.startDate : "";
      this.endDate = newHeader ? newHeader.startDate : "";
      this.rangeStart = newHeader ? newHeader.startDate : "";
      this.rangeEnd = newHeader ? newHeader.endDate : "";
      (this.startDate = this.rangeEnd), //http://tracker.globetrack.ie/issues/5712
        (this.endDate = this.rangeEnd); //http://tracker.globetrack.ie/issues/5712
    },
    value(newVal) {
      this.adults = newVal.adults;
      this.children = newVal.children;
      this.infants = newVal.infants;
      this.name = newVal.serviceName;
      this.qty = newVal.qty;
      this.perAdult = newVal.pricing ? newVal.pricing.adultSell : 0;
      this.perChild = newVal.pricing ? newVal.pricing.childSell : 0;
      this.perInfant = newVal.pricing ? newVal.pricing.infantSell : 0;
      this.perItem = newVal.pricing ? newVal.pricing.itemSell : 0;
      this.rateType = newVal.rateTypeCode ? newVal.rateTypeCode : "PP";
      this.taxCode = newVal.taxCode;
      this.statusId = newVal.statusId;
      this.statusName = newVal.statusName;
      if (newVal.startDate) {
        this.startDate = newVal.startDate;
      }
      if (newVal.endDate) {
        this.endDate = newVal.endDate;
      }
    },
  },

  methods: {
    onShowLogs() {
      this.showPricingLog = true;
    },
    getLog(pricing) {
      const {
        rateTypeCode,
        itemBuy,
        itemSell,
        adultBuy,
        adultSell,
        childBuy,
        childSell,
        infantBuy,
        infantSell,
        currencyBuy,
        currencySell,
        currencyBuyExchangeRate,
        currencySellExchangeRate,
      } = pricing;
      return {
        date: moment().format("YYYY-MM-DD"),
        username: this.$store.getters.userConfig.username,
        rateType: rateTypeCode,
        time: moment().format("HH:mm"),
        itemBuy,
        itemSell,
        adultBuy,
        adultSell,
        childBuy,
        childSell,
        infantBuy,
        infantSell,
        currencyBuy,
        currencySell,
        currencyBuyExchangeRate,
        currencySellExchangeRate,
      };
    },
    onServiceStatusChange(s) {
      this.statusId = s.id;
      this.statusName = s.name;
    },
    onRatetypeSelect(payload) {
      this.rateTypeData = { ...payload };
    },
    onDateRangeSelected(payload) {
      this.startDate = payload.dateFrom;
      this.endDate = payload.dateTo;
    },
    onTaxSelect(payload) {
      this.taxCode = payload.code;
    },
    onSave() {
      const itiItem = { ...this.itineraryItem };
      itiItem.pricing.logs.push(this.getLog(this.itineraryItem.pricing));
      this.$emit("save", itiItem);
    },
  },
  apollo: {
    rateTypes: {
      query: ALL_RATE_TYPES_SEARCH_QUERY,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ChargeEditDialog.vue